import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79d21d3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href"]

import { withDefaults, computed } from 'vue'

interface IProps {
  name: string
  color?: string
  width?: number | string
  height?: number | string
}


export default /*#__PURE__*/_defineComponent({
  props: {
    name: null,
    color: { default: '' },
    width: { default: '100%' },
    height: { default: '100%' }
  },
  setup(__props: any) {

const props = __props as { name: string, color: string, width: number | string, height: number | string }


const iconName = computed(() => `#icon-${props.name}`)
const style = computed(() => ({ color: props.color, width: props.width, height: props.height }))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    "aria-hidden": "true",
    class: "svg-icon",
    style: _normalizeStyle(_unref(style))
  }, [
    _createElementVNode("use", { "xlink:href": _unref(iconName) }, null, 8, _hoisted_1)
  ], 4))
}
}

})